
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accountB2B",
      function () {
        return require("private-next-pages/accountB2B/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accountB2B"])
      });
    }
  